import { Alpine } from '../core/alpine-core.js';
import { apiFetch } from './api.js';

Alpine.data('tvPairPage', () => ({
  pairCode: '',
  fixtureSessionId: '',
  challengeMatchId: '',
  tournamentId: '',
  tournamentMatchId: '',
  /** When set from query — user does not paste IDs */
  lockedTarget: null, // 'challenge' | 'fixture' | 'tournament' | null
  busy: false,
  message: '',
  error: '',

  init() {
    try {
      const q = new URLSearchParams(window.location.search);
      const c = String(q.get('code') || '').trim().toUpperCase();
      if (c) this.pairCode = c;
      const ch = String(q.get('challengeMatchId') || q.get('challenge') || '').trim();
      const fs = String(q.get('fixtureSessionId') || q.get('fixtureSession') || '').trim();
      const tid = String(q.get('tournamentId') || '').trim();
      const tmid = String(q.get('tournamentMatchId') || q.get('matchId') || '').trim();
      const locked = [ch && 'challenge', fs && 'fixture', tid && tmid && 'tournament'].filter(Boolean);
      if (locked.length > 1) {
        this.error = 'Use only one pairing target in the URL (challenge, fixture, or tournament match).';
        return;
      }
      if (ch) {
        this.challengeMatchId = ch;
        this.lockedTarget = 'challenge';
      } else if (fs) {
        this.fixtureSessionId = fs;
        this.lockedTarget = 'fixture';
      } else if (tid && tmid) {
        this.tournamentId = tid;
        this.tournamentMatchId = tmid;
        this.lockedTarget = 'tournament';
      }
    } catch { /* ignore */ }
  },

  async submitPair() {
    this.message = '';
    this.error = '';
    const code = String(this.pairCode || '').trim().toUpperCase();
    if (!code) {
      this.error = 'Enter the pair code from the TV.';
      return;
    }
    const fs = String(this.fixtureSessionId || '').trim();
    const ch = String(this.challengeMatchId || '').trim();
    const tid = String(this.tournamentId || '').trim();
    const tmid = String(this.tournamentMatchId || '').trim();
    const targets = [fs, ch, tid && tmid].filter(Boolean);
    if (targets.length !== 1) {
      this.error = 'Choose one pairing target: fixture session, challenge, or tournament match.';
      return;
    }
    this.busy = true;
    try {
      const body = fs
        ? { pairCode: code, fixtureSessionId: fs }
        : ch
          ? { pairCode: code, challengeMatchId: ch }
          : { pairCode: code, tournamentId: tid, tournamentMatchId: tmid };
      const res = await apiFetch('/tv-sessions/pair', { method: 'POST', body });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.message || 'Pair failed');
      this.message = 'Paired successfully. The TV should show this match within a few seconds.';
    } catch (e) {
      this.error = e.message || 'Pair failed';
    } finally {
      this.busy = false;
    }
  },
}));
